import { ReactNode } from 'react'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import { Subtitle } from '../../typography'
import Icon from './field-icon'
import Help from './help'

type Props = {
    children?: ReactNode
    className?: string
    field: CreationToolSuperCutField
}

const CreationSuperCutFieldTitle = ({ children, className, field }: Props) => {
    const title = CreationToolSuperCutField.title(field)
    return (
        <Subtitle className={className}>
            <Icon field={field} />
            {title}
            {children}
            <Help field={field} />
        </Subtitle>
    )
}

export default CreationSuperCutFieldTitle
